import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { postData } from "../api/client";
import endpoints from "../api/endpoints";
import { useSiteLogo } from "../api/siteLogo";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const logo = useSiteLogo();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!email) {
      setError("Please enter your email");
      return;
    }

    setLoading(true);
    try {
      if (endpoints.FORGOT_PASSWORD) {
        const res = await postData(endpoints.FORGOT_PASSWORD, { email });
        setMessage(res?.message || "If the email exists, a reset link was sent.");
      } else {
        setMessage("If the email exists, a reset link was sent.");
      }
      setEmail("");
    } catch (err) {
      setError(err?.message || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Breadcrumb title="Forgot Password" />

      <div className="auth-area py-120">
        <div className="container">
          <div className="col-md-5 mx-auto">
            <div className="auth-form">
              <div className="auth-header">
                <img src={logo} alt="Kademy Logo" />
                <p>Reset your Kademy account password</p>
              </div>

              <form onSubmit={handleSubmit}>
                {message && (
                  <p className="text-success" style={{ marginBottom: 8, textAlign: "center" }}>
                    {message}
                  </p>
                )}
                {error && (
                  <p className="text-danger" style={{ marginBottom: 8, textAlign: "center" }}>
                    {error}
                  </p>
                )}

                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-envelope"></i>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="auth-btn">
                  <button type="submit" className="theme-btn" disabled={loading}>
                    <span className="far fa-key"></span>
                    {loading ? " Sending..." : " Send Reset Link"}
                  </button>
                </div>
              </form>

              <div style={{ textAlign: "center", marginTop: 16 }}>
                <p className="auth-bottom-text" style={{ margin: 0 }}>
                  Remembered your password? <Link to="/login" style={{ marginLeft: 8 }}>Login.</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ForgotPassword;
